export default "__VITE_ASSET__cDSIB95T__"